/**
 * Created by PanJiaChen on 16/11/18.
 */

import Vue, { VNode } from "vue";
import { materialRouter } from "../router/modules/material";
import store from "../store/index";
import { downloadGET } from "@/api/api";
import moment from "moment";
import dayjs from "dayjs";
import { message, Modal } from "ant-design-vue";
import i18n from "@/locales";
import { defaultRoutes } from "@/utils/commonDef";
import {  getLocalStorage } from "@/utils/storage";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time: any, cFormat: any) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj: any = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(
    /{([ymdhisa])+}/g,
    (result: any, key: any) => {
      const value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") {
        return ["日", "一", "二", "三", "四", "五", "六"][value];
      }
      return value.toString().padStart(2, "0");
    }
  );
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time: any, option: any) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d: any = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url: any) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj: any = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs: any, $1: any, $2: any) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str: any) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual: any) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }

  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json: any) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url: any) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val: any) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target: any, source: any) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element: any, className: any) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type: any) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func: any, wait: any, immediate: any) {
  let timeout: any, args: any, context: any, timestamp: any, result: any;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (this: any, ...args: any) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source: any) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments");
  }
  const targetObj: any = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr: any) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt(JSON.stringify((1 + Math.random()) * 65536)) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele: any, cls: any) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele: any, cls: any) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele: any, cls: any) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

export function generateId(n: any) {
  var random = function () {
    // 生成10-12位不等的字符串
    return Number(Math.random().toString().substr(2)).toString(36); // 转换成十六进制
  };
  var arr: any = [];

  function createId() {
    var num = random();
    var _bool = false;
    arr.forEach((v: any) => {
      if (v === num) _bool = true;
    });
    if (_bool) {
      createId();
    } else {
      arr.push(num);
    }
  }

  var i = 0;
  while (i < n) {
    createId();
    i++;
  }
  return arr[0];
}

//表单序列化
export const serialize = (data: any) => {
  let list: any = [];
  Object.keys(data).forEach((ele) => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join("&");
};

interface IdNameObj {
  id: string | number;
  name: string;
}

// 把map定义 转换成输出id name的对象
export const parseMap = (obj: any) => {
  const arr: IdNameObj[] = [];
  if (Object.keys(obj).length === 0) {
    return arr;
  }
  for (let key in obj) {
    arr.push({
      id: key,
      name: obj[key],
    });
  }
  return arr;
};

export const getFirstMenu = (menus: any, appCode: string) => {
  function first(r: any): any {
    if (!r.children || r.children.length === 0) {
      return r.data && r.data.path ? r.data.path : "/";
    }
    return first(r.children[0]);
  }
  // 如果是物料仓储app进第一个
  const wmsRoutes = store.state.permission.wmsRoutes;
  if (appCode === "material") {
    if (wmsRoutes.length === 0) {
      return materialRouter[0].path;
    }
    return materialRouter[0].path + "?materialId=" + wmsRoutes[0].id;
  }
  const path = menus && menus.length > 0 ? "/redirect" + first(menus[0]) : "/";
  return path;
};

// 获取默认菜单 用于页面刷新，如果不能获取，则为空
export const isTopathExist = (routes: any, path: string) => {
  if (defaultRoutes.includes(path)) {
    return true;
  }
  let flag = false;
  materialRouter.forEach((res) => {
    if (res.path === path) {
      flag = true;
    }
  });
  if (flag) {
    return flag;
  }
  function parseRouter(routes: any) {
    routes.forEach((route: any) => {
      if (route.path === path) {
        flag = true;
      }
      if (route.children && route.children.length > 0) {
        parseRouter(route.children);
      }
    });
  }

  parseRouter(routes);
  return flag;
};

// 交换数组中两个项顺序
export const swapArr = (arr, index1, index2) => {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0];
  return arr;
};

// 获取插槽
export function getSlot(
  vm: Vue,
  name: string = "default",
  props: any = {}
): VNode[] {
  if (!(vm instanceof Vue)) throw Error("Please input vue instance");
  const nodes1 = (vm.$scopedSlots[name] && vm.$scopedSlots[name](props)) || [];
  const nodes2 = vm.$slots[name] || [];
  if (nodes2.length) {
    return [...nodes2];
  } else if (nodes1.length) {
    return [...nodes1];
  } else {
    return [];
  }
}

// 判断是否有插槽
export function hasSlot(
  vm: Vue,
  name: string = "default",
  props: any = {}
): boolean {
  if (!(vm instanceof Vue)) throw Error("Please input vue instance");
  const nodes1 = (vm.$scopedSlots[name] && vm.$scopedSlots[name](props)) || [];
  const nodes2 = vm.$slots[name] || [];
  if (nodes1.length || nodes2.length) {
    return true;
  } else {
    return false;
  }
}

// 把秒转化成21:00：00 这样时分秒的格式

export const convertSeconds = (time) => {
  if (!time || time === '--') {
    return time;
  }
  let isminus = false;
  if (time < 0) {
    isminus = true;
    time = Math.abs(time);
  }
  let hrs = Math.floor(time / 3600);
  let min = Math.floor((time - hrs * 3600) / 60);
  let seconds = time - hrs * 3600 - min * 60;
  seconds = Math.round(seconds * 100) / 100;
  let result = hrs < 10 ? "0" + hrs : hrs;
  result += ":" + (min < 10 ? "0" + min : min);
  result += ":" + (seconds < 10 ? "0" + seconds : seconds);
  if (isminus) {
    result = "-" + result;
  }
  return result;
};

// 文件流下载
export const downloadFile = (content: any, filename: string) => {
  let a = document.createElement("a");
  a.download = filename;
  a.style.display = "none";
  let url = URL.createObjectURL(content);
  a.href = url;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url); // 销毁
  document.body.removeChild(a);
};

/**
 * blob转文字
 * @param {any} content
 * @param {string} encode
 * @returns {any}
 */
export const readAsText = (content: any, encode: string) => {
  let reader = new FileReader();
  reader.readAsText(content, encode);
  return new Promise((resolve, reject) => {
    reader.onload = (e) => {
      resolve(reader.result);
    };
  });
};

/**
 * blob转地址
 * @param {any} content
 * @returns {any}
 */
export const readAsDataURL = (content: any) => {
  let reader = new FileReader();
  reader.readAsDataURL(content);
  return new Promise((resolve, reject) => {
    reader.onload = (e) => {
      resolve(reader.result);
    };
  });
};

/**
 * 获取图片
 * @param {any} file
 * @returns {any}
 * */
export const getImg = async (file: any) => {
  const res = await downloadGET(
    file.fileName,
    file.objectKey,
    file.contentType
  );
  return await readAsDataURL(res);
};

/**
 * 获取文件
 * @param {any} file
 * @returns {any}
 * */
 export const getTxt = async (file: any,val: string) => {
  const res = await downloadGET(
    file.fileName,
    file.objectKey,
    file.contentType
  );
  return await readAsText(res,val);
};

/**
 * 复制文本
 * @param {string} content
 * */
export const copyText = (content: string) => {
  let input = document.createElement("input");
  input.value = content;
  document.body.appendChild(input);
  input.select();
  document.execCommand("Copy");
  input.style.display = "none";
  document.body.removeChild(input);
};

/**
 * 计算当前选中行位于哪一页
 * @param {number} index 当前选中行位于数组(总数据)内的下标
 * @param {number} pageSize 每页的条数
 * @param {number} total 总数据条数
 * */
export const getCurrentPage = (
  index: number,
  pageSize: number,
  total: number
) => {
  // 总页数
  const totalPage = Math.ceil(total / pageSize);
  let current: number = 1;
  for (let i = totalPage; i > 0; i--) {
    if (index + 1 <= i * pageSize && index + 1 > (i - 1) * pageSize) {
      current = i;
    }
  }
  return current;
};

// 判断单据设置是否展示
// 1--表单显示表单显示，，2--列表显示列表显示	，3--表单和列表显示  4	--高级搜索高级搜索
// type传入 1,2,3,4
export const isDisplayShow = (isDisplay, type) => {
  if (type === 1) {
    // 1, 1+2, 1+4, 1+2+4
    return (
      isDisplay === 1 || isDisplay === 3 || isDisplay === 5 || isDisplay === 7
    );
  }
  if (type === 2) {
    // 2, 1+2, 2+4, 1+2+4
    return (
      isDisplay === 2 || isDisplay === 3 || isDisplay === 6 || isDisplay === 7
    );
  }
  if (type === 3) {
    // 3, 7
    return isDisplay === 3 || isDisplay === 7;
  }
  if ((type = 4)) {
    // 4, 4+1, 4+2, 4+1+2
    return (
      isDisplay === 4 || isDisplay === 5 || isDisplay === 6 || isDisplay === 7
    );
  }
};

export const limitNumber = (value: string | number) => {
  if (typeof value === "string") {
    return !isNaN(Number(value)) ? value.replace(/\./g, "") : 0;
  } else if (typeof value === "number") {
    return !isNaN(value) ? String(value).replace(/\./g, "") : 0;
  } else {
    return 0;
  }
};

const units = ["B", "KB", "MB", "GB", "TB", "PB"];
export function humanStorageSize(size: number | string) {
  let bytes = typeof size === "number" ? size : Number(size);
  let u = 0;
  while (Number.parseInt(String(bytes), 10) >= 1024 && u < units.length - 1) {
    bytes /= 1024;
    ++u;
  }
  return `${bytes.toFixed(1)}${units[u]}`;
}

// 判断是否为时间字符串格式
export const isDateStr = (value) => {
  var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
  var reg2 = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
  var reg3 = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

  var regExp = new RegExp(reg);
  var regExp2 = new RegExp(reg2);
  var regExp3 = new RegExp(reg3);
  if (regExp.test(value) || regExp2.test(value) || regExp3.test(value)) {
    return true;
  }
  return false;
};

export const getLocalLanguage = (val) => {
  if (val) {
    return val;
  }
  if (getLocalStorage('lang')) {
    return getLocalStorage("lang");
  }
  const navLanguage = navigator.language;
  const cnLanguageList = ["zh", "zh-CN"];
  const enLanguageList = ["en-US"];
  const jpLanguageList = ["ja","ja-JP"];
  if (cnLanguageList.includes(navLanguage)) {
    return "zh_CN";
  }
  if (enLanguageList.includes(navLanguage)) {
    return "en_US";
  }

  if(jpLanguageList.includes(navLanguage)){
    return "ja_JP";
  }
};

export const setCookie = (cname, cvalue, exdays) => {
  // 根域名
  const domain = document.domain.split(".");
  const length = domain.length;
  const href = "." + domain[length - 2] + "." + domain[length - 1];
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname + "=" + cvalue + ";" + expires + "; domain=" + href + ";path=/";
};

export const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

// 分钟格式化成 天/时/分
export function formatTimeSlot(time: number | string) {
  let newTime = typeof time === "number" ? time : Number(time);
  let date = 0;
  let hour = 0;
  let minute = 0;
  if (newTime >= 60) {
    hour = Math.floor(newTime / 60);
    minute = newTime % 60;
    if (hour >= 24) {
      date = Math.floor(hour / 24);
      hour = hour % 24;
      if (hour === 0 && minute === 0) {
        return `${date}d`;
      } else if (minute === 0) {
        return `${date}d/${hour}h`;
      }
      return `${date}d/${hour}h/${minute}m`;
    }
    if (minute === 0) {
      return `${hour}h`;
    }
    return `${hour}h/${minute}m`;
  }
  return newTime + "m";
}

export function momentFormat(time, pattern = "YYYY-MM-DD HH:mm:ss") {
  return moment(time || undefined).format(pattern);
}

export function dayjsFormat(time, pattern = "YYYY-MM-DD HH:mm:ss") {
  return dayjs(time || undefined).format(pattern);
}

// 空函数
export function noop(...args: any) {}

export function confirmDelete(fn, ...args) {
  return new Promise((resolve) => {
    Modal.confirm({
      title: i18n.t("delete_tips"),
      okText: i18n.t("yes") as string,
      okType: "danger",
      cancelText: i18n.t("no") as string,
      onOk() {
        fn(...args)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            resolve(false);
          });
      },
    });
  });
}

function success() {
  message.success(i18n.t("操作成功"));
}

function error() {
  message.error(i18n.t("操作失败"));
}

export function tdTracking(message, kv) {
  if (document.domain.indexOf("masterlink.cloud")>-1) {
    const global = window as any;
    try {
      global.TDAPP.onEvent(message, null, kv);
    } catch (error) {
      console.log("tracking", error);
    }
  }
}


export function getTenantId(token) {
  var strings = token.split("."); //截取token，获取载体
  var userinfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))));
  return userinfo.tenant_id
}